import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M15.776 11.94a4 4 0 0 1 .63.013.267.267 0 0 0 .052-.53 5 5 0 0 0-.711-.016.267.267 0 1 0 .029.532m-.836.133a4 4 0 0 0-.589.208.267.267 0 0 1-.217-.487q.325-.144.668-.236a.267.267 0 1 1 .138.515m-1.85 1.087a4 4 0 0 1 .47-.413.267.267 0 1 0-.321-.427 5 5 0 0 0-.532.468.267.267 0 0 0 .382.372m-.545.694q-.165.267-.289.556a.267.267 0 0 1-.49-.21q.138-.326.326-.627a.267.267 0 0 1 .453.281m-.61 2.024q.009-.316.066-.622a.267.267 0 0 0-.524-.097 4.6 4.6 0 0 0-.075.704.267.267 0 1 0 .533.015m.066.866q.057.31.161.605a.267.267 0 0 1-.503.177 4.6 4.6 0 0 1-.182-.685.267.267 0 1 1 .524-.097m.941 1.937a4 4 0 0 1-.375-.5.267.267 0 1 0-.45.286q.19.3.424.566a.267.267 0 0 0 .401-.352m1.181.928a4 4 0 0 1-.53-.331.267.267 0 1 0-.317.43q.286.21.6.374a.267.267 0 0 0 .247-.473m3.72-7.235a4 4 0 0 0-.577-.24.267.267 0 0 1 .166-.507q.337.111.653.272a.267.267 0 0 1-.242.475m.772.511q.24.202.447.439a.267.267 0 0 0 .401-.352 5 5 0 0 0-.505-.495.267.267 0 1 0-.343.408m1.205 1.717a4 4 0 0 0-.26-.569.266.266 0 1 1 .467-.258q.172.31.294.644a.267.267 0 0 1-.5.183m.22.926q.027.234.027.472v.064a.267.267 0 0 0 .532.008v-.036L20.6 16q0-.27-.03-.533a.267.267 0 0 0-.53.061m-.27 2.002q.117-.29.189-.596a.267.267 0 1 1 .52.122q-.082.346-.216.674a.267.267 0 0 1-.494-.2m-.436.799a4 4 0 0 1-.397.484.267.267 0 1 0 .385.369q.246-.257.45-.547a.267.267 0 1 0-.438-.306m-1.444 1.273q.195-.103.378-.226a.267.267 0 1 1 .298.443q-.207.139-.428.255a.267.267 0 1 1-.248-.472",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      d: "M13.778 13.516a3.333 3.333 0 1 0 4.445 0 .333.333 0 1 0-.445.496 2.667 2.667 0 1 1-3.555 0 .333.333 0 1 0-.446-.497"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M13.334 14.667 16 16l2.667-1.333v.666s-.2 3.334-2.667 2c-2.466 1.334-2.666-2-2.666-2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "m14 13.333 2 2.024 2-2.024V14s-.15 3.333-2 2c-1.85 1.333-2-2-2-2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#D9D9D9", fillRule: "evenodd", d: "m16 13.333 2.333 4h-4.666z", clipRule: "evenodd" })
);
var SvgFlagSlv = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSlv_default = SvgFlagSlv;

export { FlagSlv_default as default };
